import { type FieldMeta, type TopLevelDataObj } from "@hsl/fund-explorer/types";

function formatMetaValue(fund: TopLevelDataObj, meta: FieldMeta | undefined) {
    if (!meta) {
        return "";
    }
    switch (meta?.code_name) {
        default:
            return fund.data[meta.code_name];
    }
}

export default formatMetaValue;
